// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthInvalidUser_root__QUqht"};